import { ApiRoute } from 'api-base-refrence';
import { HomePageApiRoute } from './home-page.api';
export class HomePageByIdApiRoute extends ApiRoute {
  static apiName = 'site_management__home';
  static parent = HomePageApiRoute;
  static urlPattern(filter: { id: number | number[] }) {
    return `/${filter.id}`;
  }
}
